<template>
    <div class="index">

      <van-nav-bar class="nav-bar">
        <template #left>
          <img @click="$router.push('/')" src="img/home.png" style="width: 30px; ">
        </template>
        <template #right>
          <img @click="service" style="width: 30px; "
               src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAABXJJREFUaEPVmb2yDUEUhZdcFV7AzxMgUSVCgBClxHgCPIBCkeMF/IQkSAkQCxCQ4gnwAIr6bs06tc8+09M9c2YCXXXr3nvOme691l577e4+u/Sfj10LxH9E0p5u3pOSvnc/vPR+7vXmALBX0jlJBHteEv8PjXeSXkp6FYBNxrUNAAK9Jul6Q9ClAJ9Ieijp01QEUwFckXR/IPDPkn6loE4MBPlA0p2eZ6q4xgKA9cedVOLkvyXBpuVRWpj6QGoQcDh9iFq5MDYbYwAQ/FtJBOFB4LDHT2a8xh5AbkuKmWEOQEBE02gF0Bc8RQiTfYEflHQgAS3pnBpCjnFc7TJaBdEK4GNi/kbHuhcA4OVOHjBbciJAwC6Fi2Q8yCqv234h5VSLnFoAIA/cxiOyQ6Cwl+2zr4hjf2AuAqZwLZcMArCAGJRmDQBsonsPFkS3DEDxt9l+2vk7Hl8aBAlYpGeJUfxklEAzCDKFxIqjBuCbJPTMoIsCiIETEQSDwFlkbBHzDAQgG9gms/zONXFoqOENAcjseyLXAw4Em82O0UMj2SNjOFHUPXPanSDIZG1MMQQA6ZhxT2Lm0TjBx0IcynTtPWSECQACopBSlG4xCyUAyAb5eDABLNySBPO8P1YyGQRBModJMAhkdLTLrLOQXW81VwkAwcK2tY8ukQ6DySfvXbqsMjckIBWcxoN56dAuasdgUM0SQpfsMBlMhpT4P7pQTRal93+mPhHZJSsQ5XowaczlrQpyLmaACfB1a58P0tpfzCQdGwOO5qwSLFnNUoKsaLcOGnKJaWdECZFSEOMM6JyBxbEAr83Bvi3Sc7lJRqdx/XldYrELYbtIbNVMI4A8GROhPbf3QT9u0BMkQBDzuo54DeZZI84fbTQSh/OhhhXgCMAPUVT2dhDbeWonrSEMSJOC5HdsiDzjNWIWbCLZ8aIEd2ReA+B0svMEfcsgSNLMsyzC/wZP/+C1aMExC/uCZMkMqvDWhbVHA3D1IyUmy8PB8tuHlT6QBI6L9M3hNWhk0ZEcfAQ7CQBMwlL0frKBW3mfFINGIrDH5719rmVuI7Au43ljOAuA2OR+dHsZB7tNg/ubnJHgkU+ccxIAUm8JudGwVrG91+guvG8TsUPR8Hzq8yOjAeQidoeeoydkHLZxmhQSdBeO9joagC2OQsIhSPNcm7kMwGtBDgP7ZkSyLN+VK0Yb9QRIhk4XOzMT8Rpenn18omI2HosA2HfF2w+yYxljKL2dOHderwDjdEoaDVa3NACvg0EAyjtSx7N2wMnbaVDzEAz4sgr0nA3QpW2zdhSdkhVnwM/aJFiT2qM5btReayA+bHhyCm3o8L4tgFxn3oJvnEVaAeQT2uA5tRL9bkn7JX1Nn4sbuGjRdh4ktdE4WwGwVmxgPruOPVaelnRX0k1JbxIAs5xrzGfzXuseAyDuWbK9ORZ0TJBfOtcwy8ck8XOxC/5eCj7uPqlDH27izYg3emuPjgWAhVEPPm72nY8vSXpekNEHSccl/Qnv+5xAgATsrUO8jy1ecI0F4HXjDULf9d/ZLtAz3e9nkh5Jet0DjAOKbz3ivide4eQt+GqaqQCYgB0pQAiAxjJlECSOg/RiPcWbv8FbkG0AEDBp5pwLc1NsFb1H1n1Z7DNw9Zp9WwBTWC89g0x8X0RWYj0U11kKgL8AZGEcZe0uJ0VDoGzcfJXD6Y0MNJ0tlgCQN4G231gn8WtZNyd/XRXPwNUMLwHADgXrdFf2UmwG+Tse8B0cHdbn5bGNce1Wooq28QP5ZJW/4WEaZOJvNLe5nl8EQOwRBOdvWPwV6lxX8jt8LiEhCpjA4/fAVTtszO7Gx5YA4EV8qUV/mJX1iGJJAFNJHfXcP/mqiEDZsEJxAAAAAElFTkSuQmCC">
        </template>
      </van-nav-bar>
      <div class="top-info">
        <div class="main-title">{{$t("你好")}}</div>
        <div class="sub-info">{{ userInfo.username }}</div>
        <div class="main-logo"><img alt="" src="img/grab.jpg" style="border-radius: 24px;"></div>
      </div>
      <div class="account-info">
        <div class="account-info-title">
          <div class="info-content">{{ $t("我的余额") }}</div>
          <div class="info-balance">{{ $store.getters.getBaseInfo.currency }} {{ userInfo.money*1 }}</div>
        </div>
        <div class="account-info-grid">
          <div class="account-info-grid-item">
            <div class="info-num">0</div>
            <div class="info-title">{{ $t("累计收益") }}({{ $store.getters.getBaseInfo.currency }})</div>
          </div>
          <div class="account-info-grid-item"> |</div>
          <div class="account-info-grid-item" style="text-align: right;">
            <div class="info-num">0</div>
            <div class="info-title">{{ $t("今日收益") }}({{ $store.getters.getBaseInfo.currency }})</div>
          </div>
        </div>
      </div>
      <div class="index-scroll">
        <div class="index-scroll-tabs">
          <div class="index-scroll-tab" :class="type == 0?'tab-active':''" @click="type = 0"><img alt="" src="img/recharge_list.png">
            <div>{{ $t("开卡记录") }}</div>
          </div>
          <div class="index-scroll-tab" :class="type == 1?'tab-active':''" @click="type = 1"><img alt="" src="img/latest_recharge.png">
            <div>{{ $t("电影") }}</div>
          </div>
        </div>
        <div class="scroll-list" v-show="type == 0" ref="scrollList">
          <div class="scroll-list-item" v-for="(item,key) in recharge_list" :key = "key">
            <div class="scroll-list-item-img">
              <img alt="head"  :src="item.img">
            </div>
            <div class="scroll-list-item-text">
              <div class="scroll-list-item-text__name">{{ $t("恭喜") }} *****{{ item.mob }}</div>
              <div class="scroll-list-item-text__content">{{ $t("开卡成功") }}</div>
            </div>
          </div>
        </div>
        <div class="scroll-list" v-show="type == 1">
          <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px 8px; width: 100%;">
            <div v-for="(item,key) in movielist_0" :key="key" @click="toPlayVideo(item.id)">
              <img alt="" :src="item.vod_pic" style="width: 100%; height: 120px; object-fit: cover; border-radius: 12px;">
              <div style="width: 100%; font-size: 0.7rem;"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      type: 0,
      order_on: "",
      notice: this.$t("msg.获取中"),
      recharge_list: [],
      timer: "",
      userInfo:{

      }

    };
  },
  methods: {

    doWithdrawal() {
      if (!this.userInfo.paypassword) {
        this.$router.push("SetPayPassword");
        this.$toast(this.$t("setPayPassword.title"));
        return false;
      }

      this.$http({
        method: 'get',
        url: 'user_get_bank',
      }).then(res => {
        if (res.data.is_bank) {
          this.$router.push("withdraw");
        } else {
          this.$router.push("Setbank");
          this.$toast(this.$t("msg.请设置收款卡!"));
        }
      })
    },
    getFun(g) {
      this.$router.push({path: '/' + g})
    },
    //客服
    service() {
      window.location.href = this.$store.getters.getBaseInfo.kefu;
    },
    gotoMenu(router) {
      this.$router.replace(router)
    },
    toLottery(key, id) {
      if (!localStorage.getItem('token')) {
        this.$router.push({path: '/Login'})
      } else {
        this.$router.push({path: '/Lottery?key=' + key + "&id=" + id})
      }

    },
    toPlayVideo(id) {
      if (!localStorage.getItem('token')) {
        this.$router.push({path: '/Login'})
      } else {
        this.$router.push({path: '/PlayVideo?id=' + id})
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.getBasicConfig();
        this.isLoading = false;
        this.$toast(this.$t("msg.刷新成功！"));
      }, 500);
    },
    getBasicConfig() {
      this.$http({
        method: 'get',
        url: 'sys_config'
      }).then(res => {
        this.basicData = res.data;
        //this.getNotice(this.basicData);//获取公告
        //this.getBanner(this.basicData);//获取banner
        //this.getGameItem();//获取首页游戏列表
        this.getMovieList_0(this.basicData);//获取首页视频0
      })

    },
    getNotice(data) {
      this.notice = data.notice;
    },
    getGameItem() {
      this.$http({
        method: 'get',
        url: 'lottery_hot'
      }).then(res => {
        this.gameitem = res.data
      })
    },
    getMovieList_0(data) {
      this.movielist_0 = data.movielist_0
    },
    getBanner(data) {
      this.banners = data.banners;
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.menu_top = 15;
          if (this.userInfo.status !== 1) {
            this.$toast(this.$t("msg.账号下线"));
            localStorage.clear()
            this.$router.push({path: '/Login'})
          }
        } else if (res.code === 401) {
          this.$toast(this.$t(res.msg));
        }
      })
    },
    getRandomInt(min, max) {
      min = Math.ceil(min); // 确保最小值是整数
      max = Math.floor(max); // 确保最大值是整数
      return Math.floor(Math.random() * (max - min) + min); // 生成随机数
    }
  },
  mounted() {

    const e = this.$refs.scrollList;
    this.timer = setInterval( () => {
      e.scrollTop = e.scrollTop + 1;
      if(e.scrollTop >= (e.scrollHeight - e.clientHeight)){
        e.scrollTop = 0
      }
    }, 30);
  },

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  created() {
    let data = [];
    for(let i = 0; i < 50; i ++){
        data = [];
        data["img"] = "img/home/"+this.getRandomInt(1,12)+".png";
        data["mob"] = this.getRandomInt(1000,9999);
        this.recharge_list.push(data);
    }


    this.getUserInfo();
    this.getBasicConfig();
  }
}

</script>

<style lang='less' scoped>
.index {
  width: 100%;
  padding-bottom: 3.93333rem;
  background: #fffeef
}

.index .top-info {
  background-color: #ffb900;
  padding: 1.5vh 1.33333rem;
  box-sizing: border-box;
  text-align: left
}

.index .top-info .main-title {
  font-size: 1.4rem;
  font-weight: 700
}

.index .top-info .sub-info {
  font-size: 1rem
}

.index .top-info .main-logo {
  display: flex;
  align-items: center;
  justify-content: center
}

.index .top-info .main-logo img {
  width: 96vw
}

.index .account-info {
  box-sizing: border-box;
  margin: 1rem;
  border-radius: 1rem;
  box-shadow: 0 .33333rem 1rem rgba(0,0,0,.2);
  background: linear-gradient(90deg,#6529c9,#cc2996)
}

.index .account-info .account-info-title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  padding: 0 1rem;
  height: 5rem;
  border-radius: 1rem 1rem 0 0;
  text-align: left
}

.index .account-info .account-info-title .info-content {
  font-size: .93333rem;
  color: #fff;
  font-weight: 400
}

.index .account-info .account-info-title .info-balance {
  font-weight: 700;
  font-size: 1.4rem;
  color: #fff;
  margin-top: .53333rem
}

.index .account-info .account-info-grid {
  display: flex;
  justify-content: space-between;
  text-align: left;
  align-items: center;
  height: 5.66667rem;
  padding: 0 1rem;
  border-radius: 0 0 1rem 1rem;
  color: #fff
}

.index .account-info .account-info-grid .info-num,.index .account-info .account-info-grid .info-title,.index .account-info .account-info-grid .info-unit {
  color: #fff;
  font-size: .73333rem;
  font-weight: 400;
  line-height: 1.13333rem
}

.index .account-info .account-info-grid .info-num {
  font-size: 1.26667rem
}

.index .index-nav {
  display: grid;
  grid-template-columns: repeat(3,1fr);
  grid-template-rows: 6rem 6rem;
  margin-top: 1.33333rem;
  box-sizing: border-box;
  padding: 1rem;
  grid-column-gap: 1rem;
  grid-row-gap: 1rem
}

.index .index-nav .index-nav-item .nav-item-img img {
  width: 4rem;
  height: 4rem
}

.index .index-nav .index-nav-item .nav-item-title {
  color: #333;
  font-size: .66667rem;
  margin-top: .4rem
}

.index .index-scroll {
  padding: 1rem 0
}

.index .index-scroll .index-scroll-tabs {
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(2,1fr);
  grid-column-gap: 1rem;
  padding: 1rem
}

.index .index-scroll .index-scroll-tabs .index-scroll-tab {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-sizing: border-box;
  padding: 1.66667rem .4rem .4rem .4rem;
  position: relative;
  background-color: #fff;
  border-radius: .8rem
}

.index .index-scroll .index-scroll-tabs .index-scroll-tab img {
  height: 2.66667rem;
  position: absolute;
  margin-top: -2.66667rem
}

.index .index-scroll .index-scroll-tabs .tab-active {
  background-color: #ffb900
}

.index .index-scroll .scroll-list {
  height: 16.66667rem;
  box-sizing: border-box;
  padding: .66667rem;
  overflow-y: scroll
}

.index .index-scroll .scroll-list .scroll-list-item {
  display: flex;
  height: 6rem
}

.index .index-scroll .scroll-list .scroll-list-item .scroll-list-item-img {
  width: 4rem;
  padding: .5rem;
  display: flex;
  flex-direction: column;
  justify-content: center
}

.index .index-scroll .scroll-list .scroll-list-item .scroll-list-item-img img {
  width: 3rem;
  height: 3rem
}

.index .index-scroll .scroll-list .scroll-list-item .scroll-list-item-text {
  flex: 1;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: .66667rem
}

.index .index-scroll .scroll-list .scroll-list-item .scroll-list-item-text__name {
  font-size: .8rem;
  line-height: 1.6rem;
  color: #333;
  font-weight: 600
}

.index .index-scroll .scroll-list .scroll-list-item .scroll-list-item-text__content {
  font-size: .8rem;
  line-height: 1.6rem;
  color: #333
}
</style>
